import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { setPatientDoctorSelectorInDrawer } from "@/store/ui/ui";
import { toast } from "react-toastify";

import { RootState } from "@/store/store";
import { visitMessage } from "@/utils/constants";

function DoctorBlock({
    toggleDrawer,
    isAppointmentComplete,
}: {
    toggleDrawer: (open: boolean) => void;
    isAppointmentComplete: boolean;
}) {
    const dispatch = useDispatch();
    const errors = useSelector((state: RootState) => state.ui.errors);
    const isEditAppointment = useSelector(
        (state: RootState) => state.ui.isEditAppointment,
    );

    const doctortName = useSelector((state: RootState) =>
        isEditAppointment
            ? state.appointments?.existtAppointment?.doctorId?.name
            : state.appointments?.newAppointment?.doctorName,
    );

    const hasError = errors?.doctorName && !doctortName;

    return (
        <div
            className={`appointment_selector time-selector ${
                hasError ? "error_field" : ""
            }`}
            onClick={() => {
                if (!isAppointmentComplete) {
                    toggleDrawer(true);
                    dispatch(setPatientDoctorSelectorInDrawer("doctor"));
                } else toast.error(visitMessage);
            }}
        >
            <p style={{ color: doctortName ? "#090b0e" : "#47586E" }}>
                <span style={{ color: doctortName ? "#090b0e" : "#47586E" }}>
                    {doctortName === undefined || doctortName === null
                        ? "Дані про лікаря відсутні"
                        : doctortName === ""
                        ? "Оберіть лікаря (обов'язково)"
                        : doctortName}
                </span>
            </p>
            <img
                src='/appointmenspage/arrow-down.svg'
                alt='logo_arrow'
                className='app_arrow_img'
            />
        </div>
    );
}
export default React.memo(DoctorBlock);
